export const APP_NAME = 'changeVehicle';

export const CHANGE_VEHICLE_ROUTE_ROOT = '/changeVehicle';
